import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .FCSContent': {
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.spacing(2),
    },
  },
  '& .FCSNavCont': {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.spacing(2),
    },
  },
  '& .FCSTabs': {
    [theme.breakpoints.up('lg')]: {
      position: 'sticky',
      top: theme.spacing(5),
    },
    [theme.breakpoints.down('lg')]: {
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
  },
  '& .FCSGridorder': {
    [theme.breakpoints.down('lg')]: {
      '&:nth-child(1)': {
        order: '2',
      },
      '&:nth-child(2)': {
        order: '1',
      },
      '&:nth-child(3)': {
        order: '3',
      },
      '&:nth-child(4)': {
        order: '4',
      },
    },
  },
  '& a:not(.MuiLink-root)': {
    fontWeight: 700,
  },
}));
export default StyledBox;
